export const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_3499b8c4-f18f-4f46-8e67-97aed69a9226/artifacts/yqvvdyiz_logo.png";

export const CHANNEL_META = {
  general: { icon: "Hash", blurb: "Team banter & standups" },
  "todo-list": { icon: "CheckSquare", blurb: "My claimed tasks" },
  questions: { icon: "HelpCircle", blurb: "Architecture & bugs" },
  prompts: { icon: "Terminal", blurb: "Prompt engineering" },
  "voice-meets-ai": { icon: "Mic", blurb: "Audio → notes & todos" },
  recordings: { icon: "Radio", blurb: "Record meetings with the AI" },
};

export const PRIORITY_STYLES = {
  high: "text-red-300 bg-red-950/50 border-red-800/60",
  medium: "text-amber-300 bg-amber-950/40 border-amber-800/50",
  low: "text-sky-300 bg-sky-950/40 border-sky-800/50",
};

export const STATUS_STYLES = {
  open: { label: "Open", dot: "bg-amber-400", text: "text-amber-300" },
  "in-progress": { label: "In Progress", dot: "bg-blue-400", text: "text-blue-300" },
  done: { label: "Done", dot: "bg-emerald-400", text: "text-emerald-300" },
};

export function relTime(iso) {
  try {
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return d.toLocaleDateString([], { month: "short", day: "numeric" });
  } catch {
    return "";
  }
}

export function formatDuration(secs) {
  const s = Math.max(0, Math.floor(secs || 0));
  const m = Math.floor(s / 60);
  return `${String(m).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
}

export function fmtDueDate(due) {
  if (!due) return "";
  try {
    return new Date(`${String(due).slice(0, 10)}T00:00:00`).toLocaleDateString([], {
      month: "short",
      day: "numeric",
    });
  } catch {
    return String(due).slice(0, 10);
  }
}

export function isOverdue(due, status) {
  if (!due || status === "done") return false;
  try {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return new Date(`${String(due).slice(0, 10)}T00:00:00`) < today;
  } catch {
    return false;
  }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
